"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/styles");
var _mdiMaterialUi = require("mdi-material-ui");
var _Upload = _interopRequireDefault(require("./Upload.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// ASSETS

var UploadItem = function UploadItem(_ref) {
  var className = _ref.className,
    file = _ref.file,
    onDownload = _ref.onDownload,
    onRemove = _ref.onRemove,
    _ref$editable = _ref.editable,
    editable = _ref$editable === void 0 ? true : _ref$editable,
    _ref$downloadable = _ref.downloadable,
    downloadable = _ref$downloadable === void 0 ? true : _ref$downloadable;
  var theme = (0, _styles.useTheme)();
  var classes = (0, _Upload.default)();
  if (!file) {
    return null;
  }
  var itemClasses = (0, _classnames.default)(classes.listItem, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: itemClasses
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Attachment, {
    htmlColor: theme.palette.NEUTRAL200,
    fontSize: "inherit",
    className: classes.iconAttachment
  }), /*#__PURE__*/_react.default.createElement("span", {
    role: "presentation",
    className: classes.listItemName,
    title: file.name
  }, file.name), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.listItemActions
  }, downloadable && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.actionButton,
    disableFocusRipple: true,
    disableRipple: true,
    onClick: function onClick() {
      onDownload(file);
    }
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Download, {
    fontSize: "inherit"
  })), editable && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.actionButton,
    disableFocusRipple: true,
    disableRipple: true,
    onClick: function onClick() {
      onRemove(file);
    }
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Delete, {
    fontSize: "inherit"
  }))));
};
var _default = UploadItem;
exports.default = _default;